export const myMixins = {
  data() {
    return {
      lang: {
        fallback: "en"
      },
      //   localse: [...langfullBack, "ar", "fr", "gm"],
      myItems: []
    };
  },
  methods: {
    popUp(title = this.$t("messages.warning"), type = "warning") {
      const swal = this.$swal.fire({
        title,
        type,
        showCloseButton: true,
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: this.$t("buttons.confirm"),
        closeButtonText: this.$t("buttons.close"),
        cancelButtonText: this.$t("buttons.cancel")
      });
      return swal;
    },

    translateTableHeader(headers) {
      if (headers) {
        return headers.map(
          el => (el.text = el.key ? this.$t(`table.${el.key}`) : "")
        );
      }
    }
  }
};
